import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { BlankButton, Text } from 'atoms';
import { Mr2, CursorPointerWrapper } from 'wrappers';

const template = styled.div`
  display: flex;
  align-items: center;
  color: #7D7D7D;
  font-size: 12px;

  div:nth-child(2) {
    text-decoration: underline;
  }
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(Text, Mr2),
      name: 'Icon',
      displayValue: ({ text }) => text,
    },
    {
      component: wrap(BlankButton, CursorPointerWrapper),
      name: 'Text',
      displayValue: ({ buttonText }) => buttonText,
    },
  ],
})